import '../charts/refresh_interval_picker_view.js.coffee'
import './account_data_view.js.coffee'

Namespace 'Common.Dashboard.Navbar'

class Common.Dashboard.Navbar.NavbarMenuView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/navbar/navbar_menu']
  className: 'navbar-menu'
  nonCollapsingSpace: '\u200b'

  events:
    'click .close-button': '_close'

  initialize: ({sharedSession, accountData, refreshInterval}) ->
    @sharedSession = sharedSession
    @accountData = accountData
    @refreshIntervalPickerView = new Common.Dashboard.Charts.RefreshIntervalPickerView({refreshInterval})

  render: ->
    @$el.html @template
      lastUpdatedDate: @lastUpdatedDate
      sessionName: (@sharedSession.get('title') || @nonCollapsingSpace)
    @_renderAccountImage()
    @_renderRefreshIntervalPicker()
    @_toggleCloseState(true)
    @

  _renderAccountImage: ->
    @accountDataView?.remove()
    @accountDataView = new Common.Dashboard.Navbar.AccountDataView(accountData: @accountData)
    @$('.account-info').html(@accountDataView.render().el)

  open: =>
    @_toggleCloseState(false)

  _close: ->
    @_toggleCloseState(true)

  _toggleCloseState: (isClosed) ->
    @$el.toggleClass('navbar-menu-closed', isClosed)

  _renderRefreshIntervalPicker: ->
    @$('.automatic-refresh-container').html(@refreshIntervalPickerView.render().el)

  setLastUpdatedDate: (date) ->
    @lastUpdatedDate = date
    @$('.last-updated-date').text(@lastUpdatedDate)
